import { getAirports } from '../../../shared/data-services/airport-service';
import { getDataVacationRequest } from '../../../shared/data-services/vacation-request-service';
import { Tooltip } from "@mui/material";
import { styled } from "@mui/material/styles";
import dayjs from "dayjs";

export async function getAllAirports() {
    return await getAirports();
}

export async function getMonthsView(strfechaInicio, strfechaFin) {
    const fechaInicio = new Date(strfechaInicio);
    const fechaFin = new Date(strfechaFin);
    const data = [];

    while (fechaFin >= fechaInicio) {
        const Month = new Intl.DateTimeFormat('es-CO', { month: "long" }).format(
            new Date(fechaInicio.getFullYear(), fechaInicio.getMonth(), 1)
        );
        data.push({
            Year: fechaInicio.getFullYear(),
            Month: Month.charAt(0).toUpperCase() + Month.slice(1)
        });
        fechaInicio.setMonth(fechaInicio.getMonth() + 1);
    }
    return data;
}

export async function getData(params) {
    
    const data = await getDataVacationRequest(params);
    console.log(data);
    return data.map((element, index) => ({
        id: element.request?.id || index,
        employeeId: element.employee?.employeeId?.[0] || "",
        employeeName: element.request?.employeeName || "",
        airportCode: element.campaign?.airportCode || "",
        area: element.area?.name || "",
        campaign: element.campaign?.name || "",
        campaignState: element.campaign?.active ? "Activa" : "Inactiva",
        publish: element.campaign?.published ? "Sí" : "No",
        startDate: element.period?.dateFrom || "",
        endDate: element.period?.dateTo || "",
        creationDate: element.request?.creationDate || "",
        requestState: element.request?.active ? "Activa" : "Inactiva",
        updateEmployee: element.request?.updateEmployee,
        updated: element.request?.updated ? dayjs(element.request?.updated).format('YYYY-MM-DD HH:mm') : ""
    }));
}

export async function getDataExport(params) {
    const data = await getData(params);
    const dataReal = [];

    data.forEach(element => {
        const itemReal = [
            { v: element.employeeId, t: "s" },
            { v: element.employeeName, t: "s" },
            { v: element.airportCode, t: "s" },
            { v: element.area, t: "s" },
            { v: element.campaign, t: "s" },
            { v: element.campaignState, t: "s" },
            { v: element.publish, t: "s" },
            { v: element.startDate, t: "s" },
            { v: element.endDate, t: "s" },
            { v: element.creationDate, t: "s" },
            { v: element.requestState, t: "s" },
            { v: element.updateEmployee, t: "s" },
            { v: element.updated, t: "s" }
        ];
        dataReal.push(itemReal);
    });

    return dataReal;
}

const BoldHeader = styled("span")({
    fontWeight: "bold"
});

export async function getColumns(dataShift) {
    return [
        { field: 'id', headerName: 'ID', width: 60, hide: true },
        {
            field: 'employeeId',
            headerName: 'Identificación',
            width: 150,
            renderHeader: () => <BoldHeader>Identificación</BoldHeader>
        },
        {
            field: 'employeeName',
            headerName: 'Nombre completo',
            width: 200,
            renderHeader: () => <BoldHeader>Nombre completo</BoldHeader>
        },
        {
            field: 'airportCode',
            headerName: 'Código Aeropuerto',
            width: 150,
            renderHeader: () => <BoldHeader>Código Aeropuerto</BoldHeader>
        },
        {
            field: 'area',
            headerName: 'Área',
            width: 200,
            renderHeader: () => <BoldHeader>Área</BoldHeader>,
            renderCell: (params) => (
                <Tooltip title={params.value || ''} arrow>
                    <span>{params.value}</span>
                </Tooltip>
            )
        },
        {
            field: 'campaign',
            headerName: 'Campaña',
            width: 200,
            renderHeader: () => <BoldHeader>Campaña</BoldHeader>
        },
        {
            field: 'campaignState',
            headerName: 'Estado Campaña',
            width: 150,
            renderHeader: () => <BoldHeader>Estado Campaña</BoldHeader>
        },
        {
            field: 'publish',
            headerName: 'Publicada',
            width: 120,
            renderHeader: () => <BoldHeader>Publicada</BoldHeader>
        },
        {
            field: 'startDate',
            headerName: 'Fecha Inicio',
            width: 150,
            renderHeader: () => <BoldHeader>Fecha Inicio</BoldHeader>
        },
        {
            field: 'endDate',
            headerName: 'Fecha Fin',
            width: 150,
            renderHeader: () => <BoldHeader>Fecha Fin</BoldHeader>
        },
        {
            field: 'creationDate',
            headerName: 'Fecha Solicitud',
            width: 180,
            renderHeader: () => <BoldHeader>Fecha Solicitud</BoldHeader>,
            valueGetter: (params) =>
                params.value ? dayjs(params.value).format("YYYY-MM-DD HH:mm") : ''
        },
        {
            field: 'requestState',
            headerName: 'Estado Solicitud',
            width: 150,
            renderHeader: () => <BoldHeader>Estado Solicitud</BoldHeader>
        },
        {
            field: 'updateEmployee',
            headerName: 'Usuario Actualización',
            width: 160,
            renderHeader: () => <BoldHeader>Usuario Actualización</BoldHeader>
        },
        {
            field: 'updated',
            headerName: 'Fecha Actualización',
            width: 150,
            renderHeader: () => <BoldHeader>Fecha Actualización</BoldHeader>
        }
    ];
}
